import { connect } from 'react-redux';

import config from '@config';
import {
  setDetailPanelTarget,
  hideDetailPanel,
  clearDetailPanel,
} from '@store/actions/ux';
import { updateProgram } from '@search/store/actions/programs';
import { updateResult } from '@search/store/actions/results';
import { requestProgramMoreEpisodes } from '@search/store/actions/requests';
import DetailPanel from './detailpanel';

const PROG_TYPES = {
  result: 'result',
  program: 'program',
};

const mapStateToProps = (state, ownProps) => {
  let channel = null;
  let programType = null;

  let program = state.results.find(p => p.uuid == state.ux.detailPanel.id);
  if (program) {
    programType = PROG_TYPES.result;
  } else {
    program = state.programs.find(p => p.uuid == state.ux.detailPanel.id);
    programType = PROG_TYPES.program;
  }

  if (program) {
    channel = state.channels.find(c => c.service_id == program.service_id);
  }

  return {
    display: state.ux.detailPanel.display,
    nid: state.ux.nid,
    program: program,
    channel: channel,
    programType: programType,
  };
};

const mapDispatchToPros = dispatch => ({
  closePanel: () => {
    dispatch(hideDetailPanel());
    setTimeout(() => {
      dispatch(clearDetailPanel());
    }, config.detailPanelTransitionDuration);
  },
});

export default connect(mapStateToProps, mapDispatchToPros)(DetailPanel);
